import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { VFFieldProps } from '../types';
import { FormItem } from './FormItem';
import classNames from 'classnames';
import { DateTimeInput } from '../../datetime/DateTimeInput';
import { DATA_FORM_INPUT } from '../../common/data';
import { FORM_DATETIME_ITEM } from '../../common/classes';

export type DateTimeProps = Omit<
  VFFieldProps<React.ComponentProps<typeof DateTimeInput>>,
  'value'
>;
export const DateTime = React.forwardRef<HTMLInputElement, DateTimeProps>(
  (
    {
      name,
      inlineValidation,
      validate,
      className,
      inputClassName,
      contentClassName,
      label,
      required,
      disabled,
      readOnly,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={classNames(FORM_DATETIME_ITEM, className)}
        label={label}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name}>
          {({
            input: { value, onChange, onBlur },
            meta,
          }: FieldRenderProps<any>) => {
            return (
              <DateTimeInput
                {...DATA_FORM_INPUT(name)}
                {...other}
                disabled={disabled || meta.submitting}
                readOnly={readOnly}
                className={classNames(inputClassName)}
                onChange={(newValue) => {
                  onChange({ target: { name, value: newValue } });
                }}
                onBlur={(newValue) => {
                  onBlur({
                    target: { name, value: newValue },
                  } as any as React.FocusEvent<HTMLElement>);
                }}
                value={value}
                // @ts-ignore
                ref={ref}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
